import {
  RESTAURANTS_LOADED,
  MENU_SELECTED,
  TOGGLE_CREATE_MENU,
  LOGOUT,
  PUBLISH_MENU_SUCCESS,
  TOGGLE_UPDATE_MENU,
  CREATE_MENU_SUCCESS,
  NO_RESTAURANTS_ADDED,
  DELETE_MENU_SUCCESS,
  RESTAURANTS_LOADED_ERROR,
  MENUS_LOADED,
  MENUS_LOADED_ERROR,
  GET_MENU_DETAIL,
  RESET_USER_GROUP_SELECTED,
  UPDATE_OLD_MENU,
  CLOSE_UPLOAD_MENU_MODAL,
} from "../actions/ActionTypes";

const initialState = {
  selectedMenu: null,
  menus: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case RESTAURANTS_LOADED: {
      const menus =
        payload.menus && payload.menus.items ? payload.menus.items : [];
      return {
        ...state,
        menus,
      };
    }

    case RESTAURANTS_LOADED_ERROR:
    case NO_RESTAURANTS_ADDED:
    case MENUS_LOADED_ERROR: {
      return initialState;
    }

    case MENUS_LOADED: {
      return {
        ...state,
        menus: payload,
      };
    }

    case GET_MENU_DETAIL: {
      const updateMenus = state.menus.map((menu) =>
        menu.id === payload.id ? payload : menu
      );
      return {
        ...state,
        selectedMenu: payload.id,
        menus: updateMenus,
      };
    }

    case MENU_SELECTED:
      return {
        ...state,
        selectedMenu: action.data,
      };

    case CLOSE_UPLOAD_MENU_MODAL:
    case TOGGLE_CREATE_MENU: {
      return {
        ...state,
        selectedMenu: "",
      };
    }

    case TOGGLE_UPDATE_MENU: {
      return {
        ...state,
        selectedMenu: action.data,
      };
    }

    case LOGOUT:
    case RESET_USER_GROUP_SELECTED:
      return initialState;

    case CREATE_MENU_SUCCESS: {
      return {
        ...state,
        selectedMenu: payload.id,
        menus: [...state.menus, payload],
      };
    }

    case PUBLISH_MENU_SUCCESS: {
      const updatedMenus = state.menus.map((menu) =>
        menu.id === payload.id ? payload : menu
      );

      return {
        ...state,
        menus: updatedMenus,
      };
    }

    case DELETE_MENU_SUCCESS: {
      const updatedMenus = state.menus.filter((menu) => menu.id !== payload);

      return {
        ...state,
        menus: updatedMenus,
      };
    }

    case UPDATE_OLD_MENU: {
      const updateMenus = state.menus.map((menu) =>
        menu.id === payload.id ? payload : menu
      );

      return {
        ...state,
        menus: updateMenus,
      };
    }

    default:
      return state;
  }
}
